import { axios } from '@/utils/request'

const api = {
  user: '/common/user',
  role: '/role/role',
  allRoles: '/role/role/all'
}

export default api

export function getUsers() {
  return axios({
    url: api.user,
    method: 'get'
  })
}

export function addUser(data) {
  return axios({
    url: api.user,
    method: 'post',
    data
  })
}

export function deleteUser(ids) {
  return axios({
    url: api.user,
    method: 'delete',
    data: {
      ids: ids
    }
  })
}

export function getRoles() {
  return axios({
    url: api.role,
    method: 'get'
  })
}

export function getAllRoles() {
  return axios({
    url: api.allRoles,
    method: 'get'
  })
}
